<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="formSubmitting"
  [isDisabled]="certifyForm.invalid || !readyForCertification" submitText="CERTIFY">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div *ngIf="!readyForCertification && missingFieldsMessage.length>0" class="alert alert-warning" role="alert">
      Des informations sont manquantes :<br />
      {{ missingFieldsMessage }}.<br />
      <div class="text-center mt-2">
        <button mat-flat-button color="primary" (click)="goToBuildingPage()">Renseigner</button>
      </div>
    </div>
    <div class="formContainer">
      <form [formGroup]="certifyForm">
        <div class="formGroup">
          <p>
            <span class="title">Type</span><span class="content">{{ propHelper.getTypeName(data.prop.type) }}</span>
          </p>
          <p>
            <span class="title">Description</span><span class="content">{{ data.prop.name }}</span>
          </p>
          <p>
            <span class="title">Propriétaire</span><span class="content">{{
              UserHelper.userSummmaryDisplayName(data.prop.owner) }}</span>
          </p>
          <p *ngIf="renew && !professionalCertificationOnly">
            <span class="title">Certification actuelle</span><span class="content">{{
              certificationHelper.getCertificationTypeName(data.prop.certificationType) }}</span>
          </p>
        </div>
        <div class="formGroup mt-2" *ngIf="!professionalCertificationOnly">
          <mat-form-field class="w-100">
            <mat-label>Type de certification</mat-label>
            <mat-select formControlName="type" (selectionChange)="checkCertificationRequiredField(data.prop)">
              <mat-option *ngFor="let type of getCertificationTypes()" [value]="type" [disabled]="!isTypeAllowed(type)">
                {{ certificationHelper.getCertificationTypeName(type) }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="formGroup mt-2">
          <div *ngIf="!professionalCertificationOnly"><mat-checkbox formControlName="withMaintenances">Générer les
              maintenances</mat-checkbox></div>
          <div class="formGroup">
            <mat-checkbox formControlName="syncOpenData">{{ renew ? 'Mettre à jour' : 'Récupérer'}} les données
              publiques automatiquement</mat-checkbox>
          </div>
        </div>
        <div class="formGroup mt-3">
          <p class="font-weight-bold">Documents à certifier :</p>
          <div *ngIf="docsAvailable.length > 0; else noDoc">
            <mat-checkbox name="selectAll" (change)="toggleCheckAll($event)">Tous</mat-checkbox>
          </div>
          <ng-template #noDoc>
            <span class="d-flex justify-content-center m-3">Aucun document</span>
          </ng-template>
          <ul>
            <li *ngFor="let doc of docsFormArray.controls; let i = index" formArrayName="docs">
              <mat-checkbox [formControlName]="i" (change)="docCheckBoxEvent($event)">
                {{
                propHelper.getDocumentCategoryName(docsAvailable[i].category,data.prop.type) +
                ', ' +
                propHelper.getDocumentTypeName(docsAvailable[i].type) +
                ' : ' +
                docsAvailable[i].name
                }}</mat-checkbox>
            </li>
          </ul>
        </div>
      </form>
    </div>
  </div>
</ng-template>